import styled from "styled-components";

interface IBadgeOvalStyled {
    fontSize?: number | string;
}

export const BadgeOvalStyled = styled.div<IBadgeOvalStyled>`
    display: inline-flex;
    align-items: center;
    border-radius: 26px;
    background: linear-gradient(139deg, #FFDAB9 13.35%, #C2C5FF 67.96%);

    box-shadow: 0px 7px 20px 0px rgba(194, 197, 255, 0.18);
    color: var(--color-tertiary);
    font-size: ${({ fontSize }) => fontSize ? `${fontSize}px` : '16px'};
    font-weight: 600;
    padding: 1px 6px 1px 8px;

    &.sm {
        border-radius: 20px;
        padding: 1px 4px 1px 6px;
        font-size: ${({ fontSize }) => fontSize ? `${fontSize}px` : '12px'};
    }

    &.lg {

    }

    &.cashback {
        background: linear-gradient(100deg, #FFFC58 -1.53%, #C2C5FF 73.25%);
    }
`;
